module.exports = __webpack_public_path__ + "videos/alter-ego_3-4.21ccf25.mp4";